import React from "react";
import PropTypes from "prop-types";
import {Grid, Loader} from "semantic-ui-react";
import {
    DeleteButton,
    EditButton,
    ExternalWorkflowButton,
    CancelExternalWorkflowButton,
    CopyButton,
    SubmitReviewPublishButton,
    PublishRequestButtonMenu,
} from "../buttons";
import {
    ActionMenuTooltip,
    EditButtonTooltips,
    RunQCButtonTooltips,
    getWorkflowRequest,
    getCommunitySubmissionRequest,
} from "../utils";

export const ActionMenu = ({draftId, draftRequests, isLoading, draft}) => {
    const state = draft.state;
    const status = draft.status;
    const activeCommunitySubmissionRequest = getCommunitySubmissionRequest(draftRequests);

    if (isLoading) {
        return <Loader/>;
    }

    // Render publication button based on draft.status
    const renderPublishButton = () => {
        if (status === "in_review") {
            // Show menu to navigate to review or cancel
            if (!activeCommunitySubmissionRequest) {
                return <Loader inline centered />;
            }
            return (
                <PublishRequestButtonMenu request={activeCommunitySubmissionRequest} />
            );
        }
        // For "draft" and "draft_with_review" statuses, show submit button
        return (
            <SubmitReviewPublishButton
                draftId={draftId}
                draft={draft}
                disabled={false}
            />
        );
    };

    // Determine if edit should be disabled based on status
    const isEditDisabled = ["running", "submitted"].includes(state) || status === "in_review";

    // Determine if external workflow should be disabled
    const isExternalWorkflowDisabled = ["running", "submitted"].includes(state) || status === "in_review";

    return (
        <Grid>
            <Grid.Row columns={2} style={{padding: "0"}}>
                <Grid.Column>
                    <DeleteButton draftId={draftId} state={state}/>
                </Grid.Column>
                <Grid.Column>
                    <ActionMenuTooltip
                        state={state}
                        tooltips={EditButtonTooltips}
                        trigger={
                            <EditButton
                                draftId={draftId}
                                disabled={isEditDisabled}
                            />
                        }
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2} style={{padding: "0.5rem 0 1rem 0"}}>
                <Grid.Column>
                    {state === "running" ? (
                        <CancelExternalWorkflowButton
                            request={getWorkflowRequest(draftRequests)}
                        />
                    ) : (
                        <ActionMenuTooltip
                            state={state}
                            tooltips={RunQCButtonTooltips}
                            trigger={
                                <ExternalWorkflowButton
                                    draftId={draftId}
                                    disabled={isExternalWorkflowDisabled}
                                />
                            }
                        />
                    )}
                </Grid.Column>
                <Grid.Column>
                    <CopyButton draft={draft}/>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    {renderPublishButton()}
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};

ActionMenu.propTypes = {
    draftId: PropTypes.string.isRequired,
    draft: PropTypes.object.isRequired,
    draftRequests: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
};
